angular.module('wbDashboard').controller('FormulasEditControllerAurea',
    ['$scope', '$uibModal', '$filter', '$q', 'FormulaService', 'User', 'Account', 'Message', 'Track', 'userFormulasResolve',
function ($scope, $uibModal, $filter, $q, FormulaService, User, Account, Message, Track, userFormulasResolve) {

    $scope.pageData.percent = 1;
    $scope.formulaDefault = { metadata: {}, funding: {}, milestones: [], recommended: {}, extra: { transferEst: 0 }};
    $scope.formula = angular.copy($scope.formulaDefault);

    $scope.showDiscovered = $scope.$state.current.name.includes('create') && !userFormulasResolve.length;
    $scope.taxablePIAAccount = false;
    $scope.taxablePIAPending = false;
    $scope.editing = false;

    $scope.options = {
        roundUpValues: [1, 5, 10],
        multiplyValues: [...Array(10+1).keys()].slice(1) //[1..10]
    };

    //if creating then go back to start if page was loaded in the middle of the flow
    if (   !$scope.formula.slug
        && $scope.$state.current.name !== "base.formulas.create"
        && $scope.$state.current.name.includes('base.formulas.create')) {

        $scope.$state.go('base.formulas.create');
    }

    if ($scope.showDiscovered) {
        Track.send("Formulas Discovered", "formulas");
    }

    /**
     * always make sure formulas are enabled when viewing this page
     */
    $scope.enableFormulas();
    $scope.endDiscoveredState = function() {
        $scope.showDiscovered = false;
    };

    $scope.$watch(function() { return FormulaService.user.getFormulas($scope.$stateParams.formulaSlug); }, function(formula) {
        //will be an array if formulaSlug is null on create select screen
        if (formula && !Array.isArray(formula)) {
            //initialize edit formula object from
            //actual user formula object
            $scope.editing = true;

            var tempFormula = angular.copy(formula);
            var tempDefaults = angular.copy($scope.formulaDefault);
            $scope.formula = angular.extend({}, tempDefaults, tempFormula);
            $scope.formula.milestones = $scope.formula.milestones.map(value => value.milestone_id);

            $scope.setDeposits();
            if (!$scope.$stateParams.page) {
                $scope.goNextPage({location: 'replace'});
            }

        } else if (!$scope.$state.current.name.includes('create')
                    && FormulaService.user.getFormulas() != null) {
            $scope.$state.go('base.formulas');
        }
    });

    $scope.deleteFromArray = function(arry, value) {
        var index = arry.indexOf(value);
        if (index > -1) {
            arry.splice(index, 1);
        }
    };

    $scope.$watch('overview', function(overview) {
        if (overview) {
            $scope.taxablePIAAccount = false;
            $scope.taxablePIAPending = false;
            angular.forEach(overview.account_overview, function(account) {
                if (account.type === "personal-investment-account") {
                    $scope.taxablePIAAccount = true;
                    if (account.is_pending) {
                        $scope.taxablePIAPending = true;
                    }
                }
            });
        }
    });
    $scope.$watchCollection(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            angular.forEach(milestones, function(ms) {
                //needs retirement milestone id to know what milestone to add the PIA to
                if (ms.type === 'retirement') {
                    $scope.retirementMilestone = ms.id;
                }
            });
        }
    });

    $scope.$watchCollection('formula.milestones', function(milestones) {
        if (milestones) {
            $scope.updateTransferEst();
        }
    });
    $scope.$watch('formula.metadata', function(meta) {
        if (meta) {
            $scope.updateTransferEst();
        }
    }, true);
    $scope.updateTransferEst = function() {
        $scope.formula.extra.transferEst = FormulaService.getPotentialTransfer($scope.formula)
                                            * $scope.formula.milestones.length;
    };

    $scope.addPIA = function(msId) {
        $scope.pageData.sending = true;
        Account.addPIAModal(msId, "Formulas").then(function(response) {
            User.retrieveMilestones(msId, true);
            User.retrieveActivityPending(true);
            return User.retrieveOverview(true);
        }).then(function(response) {
            Message.set({
                text:"Personal Account has been added.",
                type: "success"
            });
        }).catch(function(response) {
            if (response) {
                //if the modal was only closed there is no response
                Message.set({
                    text: "Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
            }
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.userHasFormula = function(f) {
        return !!FormulaService.user.getFormulas(f.slug);
    };
    $scope.showSelectSubtitle = function(f) {
        var userFormulas = FormulaService.user.getFormulas();
        var formulas = FormulaService.getFormulas();
        var unused = [];
        if (userFormulas && formulas) {
            userFormulas = userFormulas.map(value => value.slug);
            formulas = formulas.map(value => value.slug);
            unused = formulas.filter(value => !userFormulas.includes(value));
        }
        return unused[0] === f.slug || unused[1] === f.slug;
    };

    $scope.setFormula = function(formula) {
        if ($scope.userHasFormula(formula)) { return; }
        if (formula.slug !== $scope.formula.slug) {
            $scope.formula = angular.copy($scope.formulaDefault);
            $scope.formula.title = formula.title;
            $scope.formula.slug = formula.slug;
        }
        $scope.goNextPage();
    };

    $scope.setDeposits = function() {
        var data = {
            formulaSlug: $scope.formula.slug,
            metadata: $scope.formula.metadata,
            milestones: $scope.formula.milestones,
        };

        if ($scope.walletMS && !$scope.formula.funding.auto_deposit) {
            $scope.formula.funding.auto_deposit = $scope.walletMS.auto_deposit.amount;
        }

        FormulaService.getFormulasAutoRecommend(data).then(function(deposits) {
            if (deposits) {
                $scope.formula.recommended.auto = deposits.auto.total;
                $scope.formula.recommended.one_time = deposits.one_time.total;
            }
        });
    };

    $scope.setMilestone = function() {
        var msId;
        var msKeys = $scope.milestoneChoices && Object.keys($scope.milestoneChoices);
        if (msKeys && msKeys.length === 1) {
            msId = $scope.milestoneChoices[msKeys[0]].id;
            if (!$scope.formula.milestones.includes(msId)) {
                $scope.formula.milestones.push(msId);
            }
        }
    };

    $scope.submitFormula = function() {
        $scope.pageData.sending = true;

        var data = angular.copy($scope.formula);

        //required for url
        data.formulaSlug = data.slug;

        delete data.title;
        delete data.description;
        delete data.slug;
        delete data.extra;
        delete data.metrics;

        if (!data.funding.deposit) {
            data.funding.deposit = 0;
        }
        if (data.metadata.bargain_hunting_percent) {
            data.metadata.bargain_hunting_percent = data.metadata.bargain_hunting_percent / 100;
        }

        FormulaService.saveFormula(data).then(function(response) {
            User.retrieveOverview(true);
            User.retrieveAllMilestones(true);
            // User.retrieveWalletMS(true); //wallet ms might not exist yet?
            User.retrieveActivityPending(true);

            return $q.all([FormulaService.user.retrieveFormulas(true), FormulaService.retrieveFormulas(true)]);
        }).then(function() {
            var action = "enabled";
            if ($scope.editing) {
                action = "updated";
            }
            Message.set({
                text:`Successfully ${action} ${$scope.formula.title} Formula`,
                type: "success"
            });
            $scope.$state.go("base.formulas");
        }).catch(function() {
            $scope.pageData.sending = false;
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };


    /*******************************************************
     * Actions preformed to initialize page, or change page
     *******************************************************/

    $scope.goNextPage = function(options) {
        var nextPage = null;
        // after current page
        switch ($scope.$stateParams.page) {
            case 'bargain-hunting-1':
                nextPage = $scope.formula.slug + '-2';
                break;
            case 'round-up-1':
            case 'multiply-dividends-1':
            case 'bargain-hunting-2':
            case 'level-up-1':
                nextPage = 'milestones';
                break;
            case 'milestones':
                // if (!$scope.walletMS) {
                //     nextPage = 'funding-info';
                // } else {
                //     nextPage = 'fund-wallet';
                // }
                nextPage = 'confirm';
                break;
            case 'funding-info':
                nextPage = 'fund-wallet-first';
                break;
            case 'fund-wallet-first':
            case 'fund-wallet':
                nextPage = 'wallet-autos';
                break;
            case 'wallet-autos':
                nextPage = 'confirm';
                break;
            case 'confirm':
                nextPage = 'confirm';
                break;
            case 'start':
            /* falls through */
            default:
                switch ($scope.formula.slug) {
                    default:
                        nextPage = $scope.formula.slug + '-1';
                }
                break;
        }
        // nextPage = $scope.beforePage(nextPage);

        if ($scope.$stateParams.page === 'confirm') {
            $scope.submitFormula();
        } else {
            $scope.goToPage(nextPage, options);
        }

    };
    $scope.beforePage = function(page) {
        var nextPage = page;

        switch (nextPage) {
            case 'milestones':
                $scope.setMilestone();
                break;
            case 'fund-wallet-first':
            case 'fund-wallet':
            case 'wallet-autos':
                $scope.setDeposits();
                break;
        }
        if (nextPage !== page) {
            nextPage = $scope.beforePage(nextPage);
        }
        return nextPage;
    };
    $scope.goToPage = function(page, options = {}) {
        if ($scope.$state.current.name.includes('create')) {
            return $scope.$state.go('base.formulas.create.steps', {formulaSlug: $scope.formula.slug, page: page}, options);
        } else if ($scope.$state.current.name.includes('edit')) {
            return $scope.$state.go('base.formulas.edit.steps', {formulaSlug: $scope.formula.slug, page: page}, options);
        }
    };
    $scope.setPercent = function(page) {
        switch (page) {
            case $scope.formula.slug + "-1":
                $scope.pageData.percent = 10;
                break;
            case $scope.formula.slug + "-2":
                $scope.pageData.percent = 20;
                break;
            case 'milestones':
                $scope.pageData.percent = 30;
                break;
            case 'funding-info':
                $scope.pageData.percent = 40;
                break;
            case 'fund-wallet-first':
            case 'fund-wallet':
                $scope.pageData.percent = 60;
                break;
            case 'wallet-autos':
                $scope.pageData.percent = 80;
                break;
            case 'confirm':
                $scope.pageData.percent = 100;
                break;
            case undefined:
                $scope.pageData.percent = 1;
                break;
            case 'start':
            /* falls through */
            default:
                $scope.pageData.percent = 10;
                break;
        }
    };
    $scope.setPercent($scope.$stateParams.page);

    var redirected = false;
    var transitionDeregisterHook = $scope.$transitions.onBefore({
        to: (state) => (state.name.includes('base.formulas.edit.steps') || state.name.includes('base.formulas.create.steps'))
    }, function(trans) {
        var to = trans.to();
        var toParams = trans.params('to');
        var updatedPage;
        $scope.setPercent(toParams.page);

        if (!to.name.includes('edit') && !$scope.formula.slug) {
            return trans.router.stateService.target('base.formulas.create');
        }

        if (!redirected) {
            updatedPage = $scope.beforePage(toParams.page);

            if (updatedPage !== toParams.page) {
                redirected = true;
                return trans.router.stateService.target(to.name, {
                    formulaSlug: $scope.formula.slug,
                    page: updatedPage
                });
            }
        }

        redirected = false;

        return true;
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });


}]);
